// extracted by css-extract-rspack-plugin
export default {"cls1":"LoggedOutDiscoveryPage-cls1_Ows","cls2":"LoggedOutDiscoveryPage-cls2_qFo LoggedOutDiscoveryPage-cls1_Ows"};